module.exports = __webpack_public_path__ + "img/09.6dbe3f39.png";